import { useEffect, useState } from "react";
import axios from "../axios";

const useTodayTrialLessons = () => {
  const [trialLessons, setTrialLessons] = useState([]);
  const [trialLoading, setTrialLoading] = useState(true);

  useEffect(() => {
    const fetchLessons = async () => {
      try {
        const res = await axios.get("trial-lesson/all");
        const allLessons = res.data;
         console.log(res)
        const today = new Date().toLocaleDateString("en-US", {
          weekday: "long",
        }).toLowerCase(); 

        const todayLessons = allLessons.flatMap((student) =>
          student.classSchedule
            ?.filter((s) => s.day.toLowerCase() === today)
            .map((s) => ({
              name: student.name,
              time: s.time,
              teacher: student.teacherName,
              teacherId: student.teacherId,
              teacherSchoolId: student.teacherSchoolId,
              phoneNumber: student.phoneNumber,
            }))
        );
        const filtred = todayLessons.filter(({teacherId}) => teacherId !== 'removed')
        setTrialLessons(filtred);
      } catch (error) {
        console.error("Error fetching trial lessons:", error);
      } finally {
        setTrialLoading(false);
      }
    };

    fetchLessons();
  }, []);

  return { trialLessons, trialLoading };
};

export default useTodayTrialLessons;
